import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSignup = ({ isDark, source = 'site', compact = false }) => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/api/newsletter/subscribe`, { email, source });
      toast.success(data.already_subscribed ? 'Already subscribed' : 'Subscribed', { description: data.message });
      if (!data.already_subscribed) setEmail('');
    } catch (err) {
      toast.error('Could not subscribe', { description: err?.response?.data?.detail || 'Please try again.' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form data-testid="newsletter-form" onSubmit={submit} className={compact ? 'w-full' : 'w-full max-w-md'}>
      {!compact && (
        <h4 className={`text-xs font-bold uppercase tracking-wider mb-3 ${isDark ? 'text-zinc-500' : 'text-zinc-400'}`}>
          The Leakage Report
        </h4>
      )}
      <p className={`text-xs mb-3 leading-relaxed ${isDark ? 'text-zinc-500' : 'text-zinc-500'}`}>
        One issue a fortnight on cross-channel leakage, quick-commerce and agency ops. No fluff.
      </p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail size={14} className={`absolute left-3 top-1/2 -translate-y-1/2 ${isDark ? 'text-zinc-600' : 'text-zinc-400'}`} />
          <input data-testid="newsletter-email" type="email" required value={email} aria-label="Email address"
            onChange={(e) => setEmail(e.target.value)} placeholder="you@brand.com"
            className={`w-full pl-9 pr-3 py-2 rounded-md text-sm outline-none transition-colors border
              ${isDark ? 'bg-zinc-900 border-zinc-800 text-zinc-200 focus:border-zinc-600'
                       : 'bg-white border-zinc-200 text-zinc-800 focus:border-zinc-400'}`} />
        </div>
        <button data-testid="newsletter-submit" type="submit" disabled={busy}
          className="px-4 py-2 rounded-md text-sm font-bold text-white transition-all hover:shadow-lg hover:shadow-blue-500/20 disabled:opacity-60"
          style={{ background: 'linear-gradient(135deg,#002FA7,#00D4FF)' }}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : 'Join'}
        </button>
      </div>
    </form>
  );
};

export default NewsletterSignup;
